<script lang="ts">
	import CollectionsNav from '$lib/components/CollectionsNav/CollectionsNav.svelte';
	import CollectionsNavigationFooter from './CollectionsNavigationFooter.svelte';
	import Cover from '$lib/components/cover/Cover.svelte';
	import CollectionsHeaderBar from '$lib/components/headerBar/CollectionsHeaderBar.svelte';
	import Stream from './Stream.svelte';
	import SparqFooter from '$lib/components/SparqFooter/SparqFooter.svelte';
	import { getHubStores } from '$lib/stores/hubStores';
	import type { PageData } from './$types';
	import SideBar from '$lib/components/CollectionsNav/SideBar/SideBar.svelte';
	import { afterNavigate } from '$app/navigation';
	import { isSmallScreen } from '$lib/stores/resizeStore';
	import type { Device } from '$lib/types/Device';

	export let data: PageData;

	let device: Device;
	$: device = $isSmallScreen ? 'mobile' : 'desktop';

	const { hub, posts } = getHubStores();
	afterNavigate(() => {
		posts.set(data.respPosts.posts);
	});
</script>

<SideBar />
<CollectionsHeaderBar {hub} {device} />
{#if !$hub.theme.coverHideCover}
	<Cover {hub} {device} />
{/if}

<CollectionsNav />
<Stream nextPage={data?.respPosts?.pages.next} />
<CollectionsNavigationFooter />
<SparqFooter />
